<div *ngIf="!elementsOptions.clientSecret">
  <h2>Loading ...... Please Wait</h2>
</div>
<div
  *ngIf="elementsOptions.clientSecret"
  class="p-4 m-2 rounded-md surface-card shadow-2 border-round">
  <div class="mb-3 text-3xl font-medium text-primary-500">
    Payment Information
  </div>
  @if (elementsOptions.clientSecret) {
  <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
    <ngx-stripe-address #billingAddress [options]="billingAddressOptions" />
    <ngx-stripe-payment [options]="paymentElementOptions" />
  </ngx-stripe-elements>
  }
  <div class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
    <div class="w-full text-white md:flex-order-0 flex-order-1">
      <span class="pi pi-credit-card"></span>
      <span class="pl-2">
        This payment method will be set for automatic processing of all future
        payments
      </span>
    </div>
    <div class="w-full text-white align-middle md:flex-order-0 flex-order-1">
      <span class="align-middle" id="switch2">Autopay Enabled</span>
      <p-toggleswitch
        [(ngModel)]="checked"
        class="m-2 align-middle"
        (onChange)="toggleSwitchChanged($event)"
        ariaLabelledBy="switch2" />
    </div>
  </div>
  <div class="flex flex-wrap w-full p-2 m-2 align-items-center surface-ground">
    <p-button
      class="w-full p-4 m-2 text-center rounded-md lg:w-4/12 bg-primary-500 disabled:bg-slate-300"
      severity="success"
      [disabled]="paying()"
      [label]="getButtonLabel()"
      (onClick)="pay()"
      icon="pi pi-wallet" />
    <p-button
      class="w-full p-4 m-2 text-center rounded-md lg:w-4/12 bg-primary-500 disabled:bg-slate-300"
      severity="success"
      [disabled]="paying()"
      label="Cancel"
      (onClick)="cancel()"
      icon="pi pi-times-circle" />
  </div>
  <div *ngIf="paying()" class="w-full text-white md:flex-order-0 flex-order-1">
    <span class="pi pi-credit-card"></span>
    <span class="pl-2">
      Processing .... please wait (do not refresh your browser)
    </span>
  </div>
</div>
